import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FetchApi from '../../../customhooks/Functionapi';
import { RejectGrouplist } from './functionReject';
import { showSendingLoading } from '../aprovedStatusAll/ApprovedFunction';
import { toast } from 'react-toastify';

import Swal from 'sweetalert2';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const Poprejectgroup = (props) => {
    const FetchApis = new FetchApi();
    const UserId = sessionStorage.getItem("userId");
    const [open, setOpen] = React.useState(false);
    const [inputText, setInputText] = useState("");

    const [listdata, setListdata] = useState([]);
    const [journallist, setJournallist] = useState([]);

    const handleClickOpen = () => {
        setOpen(true);
        getjournalgrouplist()
    };
    const handleClose = () => {
        setOpen(false);
    };

    function getjournalgrouplist() {
        FetchApis.FethcGet(`/JournalBygroup/journalgroupBycode/${props.jourId}`).then(res => {
            if (res) {
                var datacall = res.data[0];
                setListdata(datacall)
                setJournallist(res.data)
            }
        });
    }


    function saverejct() {

        // ต้องมีผู้ถูกตีกลับ (ผู้สร้างเอกสาร) + comment ก่อน : ตรวจก่อนบันทึก note จะได้ไม่มี note ค้างเมื่อ reject ไม่ผ่าน
        const missing = [];
        if (journallist.length == 0 || journallist.some(item => !item.createBy)) missing.push("ไม่พบผู้สร้างเอกสาร (ผู้ถูกตีกลับ) ของกลุ่มนี้");
        if (!inputText.trim()) missing.push("กรุณาใส่รายละเอียดการ Reject");

        if (missing.length > 0) {
            Swal.fire({
                title: "แจ้งเตือน",
                text: missing.join(" และ "),
                icon: "warning",
                didOpen: () => {
                    Swal.getContainer().style.zIndex = 2000; // แสดงเหนือ Dialog ของ MUI
                }
            });
            return;
        }

        var objectnote = {
            groupId: props.jourId,
            notedetail: inputText,
            rejectBy: UserId,
            stateflow: listdata.stateflow,
            jourstatus: "R1001"
        }

        Swal.fire({
            title: "แจ้งเตือน",
            text: "คุณต้องการบันทึก Reject ใช่หรือไม่ ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "บันทึก",
            cancelButtonText: "ยกเลิก"
        }).then(async (result) => {
            if (result.isConfirmed) {
                // console.log(objectnote);

                // รอบันทึก reject + ส่งเมลครบทุกเอกสารก่อนเปลี่ยนหน้า (ถ้าไม่รอ request ที่ค้างอยู่จะถูกยกเลิก)
                showSendingLoading();
                try {
                    const res = await FetchApis.FethcPost(`/noterejectgroup/NoteRejectgroup`, objectnote)
                    // console.log(res)
                    // บันทึก note (ผู้ reject) ไม่สำเร็จ : ไม่ทำ reject ต่อ เพราะจะไม่มีชื่อผู้ reject
                    if (!res || res.status != 200) {
                        Swal.fire({ title: "แจ้งการบันทึก", text: "บันทึก Reject ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", icon: "error" });
                        return;
                    }

                    const resultlist = await RejectGrouplist(journallist, UserId)
                    const failed = resultlist.filter(r => !r || r.status != 200);
                    if (failed.length > 0) {
                        Swal.fire({ title: "แจ้งการบันทึก", text: `Reject ไม่สำเร็จ ${failed.length} เอกสาร กรุณาตรวจสอบอีกครั้ง`, icon: "error" });
                        return;
                    }
                    await sendEmail(journallist[0].JournalCode, '1')
                } catch (err) {
                    console.log(err);
                }
                Swal.close();

                setTimeout(() => {
                    setOpen(false);
                    window.location.href = '/approvelist'
                }, 1500);

                toast.success('รอสักครู่ กำลังโหลดข้อมูล!', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    // transition: Bounce,
                });

            }
        });

        setOpen(false);

    }

        const sendEmail = (JournalCode, stateflow) => {
        // journalCode,stateflow, TypeEvent, datetimes
        console.log('send email', JournalCode, stateflow);
        
        return FetchApis.FethcPost(`/flowrunsystem/sendEmailflowgroup`, {
            journalCode: JournalCode,
            stateflow: stateflow,
            TypeEvent: 'reject',
            datetimes: '',
         
        }).then(res => {
            if (res) {
                console.log(res.data)
            }
        })
    }   


    return (
        <React.Fragment>
            <Button variant="contained" onClick={handleClickOpen} style={{ marginLeft: 10 }} color='warning'>
                reject
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    อธิบายรายละเอียดการ Reject ผู้สร้างเอกสาร
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div style={{ width: 500, height: 150 }}>
                        <textarea style={{ width: 500, height: 150 }} maxLength={350} value={inputText}
                            onChange={(e) => setInputText(e.target.value)} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => saverejct()} variant="outlined" color='success'>
                        Save
                    </Button>
                    <Button autoFocus onClick={handleClose} variant="outlined" color='warning'>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Poprejectgroup